export default {
    message: {
        contact: {
            companyNameExample: 'E.g ABC Limited',
            companyNumberLabel: 'Company number',
            companyNumberPlaceholder: 'Company number',
            companyNumberPlaceholderForCompanyMobile: 'Company number',
            ownerNamePlaceholderForCompany: 'Enter the full name of the Company including "Limited"',
        },
        price: {
            tax: 'TAX',
        },
    }
};
